module.exports = __webpack_public_path__ + "img/goodies.f81004bc.png";